<template>
  <div class="hotelCard__item" :class="{'activate': isActive}" @click="mode === MODE_CLICKABLE_CONTAINER ? goToHotel() : () => {}" v-loading="isSaving">
    <div class="hotelCard__item__cover cursor-pointer">
      <div v-if="coverExist" class="image" v-lazy:background-image="hotelCover"></div>
      <div v-else class="image" v-lazy:background-image="require('@/assets/images/default-room.jpg')"></div>
    </div>
    <div class="hotelCard__item__info p-0 md:p-8">
      <!-- <div class="hotelCard__item__basic overflow-hidden">
        <a class="hotelCard__link inline-block text-grey-darkest" @click="mode === MODE_CLICKABLE_CONTAINER ? () => {} : goToHotel()">
          <h6 class="font-semibold leading-md text-overflow-ellipsis">{{ hotelData.hotelNameLocal }}</h6>
          <div v-if="hotelData.hotelNameEN && selectedLang !== 'en'" class="font-semibold text-sm text-overflow-ellipsis">{{ hotelData.hotelNameEN }}</div>
        </a>
        <div class="flex items-center mt-4">
          <div v-if="hotelData.quarantineHotelNote" class="inline-flex items-center text-xs text-grey-darkest font-bold mr-16">
            <img height="14px" width="14px" src="@/assets/quarantine-hotels/icon-hotel.svg" class="mr-4" alt="quarantine-hotel" />
            <span>{{ $t('quarantine.label') }}</span>
          </div>
          <div v-if="hotelData.filterHash && hotelData.filterHash.star && starFilter.length > 0 && getStarFilter(hotelData.filterHash.star, starFilter)[0].star" class="inline-flex items-center flex-1 text-xs whitespace-no-wrap">
            <i class="rank-wrap bg-orange mr-4 rounded-full text-white owl-rank-star flex items-center justify-center" />
            <span class="font-semibold">{{ $t('unit.star', [$t('number')[getStarFilter(hotelData.filterHash.star, starFilter)[0].star]]) }}</span>
          </div>
        </div>
        <div class="location text-xs mt-8">
          <span v-if="hotelData.placesText">{{ hotelData.placesText }}</span>
          <span v-if="hotelData.hotelType && hotelData.hotelType.name !== 'unknown'" :class="{ 'border-l-1 border-grey-dark mx-8 px-8': hotelData.placesText }">{{ hotelData.hotelType.name }}</span>
        </div>
        <div class="tags flex mt-16">
          <div v-if="hotelData.tags && hotelData.tags.length > 0" class="flex flex-wrap">
            <div class="bg-grey-darkest text-white text-xs p-4 mr-4" :key="hotelData.tags[0].id">{{ hotelData.tags[0].name }}</div>
            <el-tooltip effect="dark" placement="right">
              <div v-if="hotelData.tags.length > 1" class="tags__more bg-grey-darkest text-white text-xs p-4 mr-4">{{ hotelData.tags.length - 1 }}+</div>
              <div slot="content">
                <div v-for="(tag, index) in hotelData.tags.slice(1)" :key="tag.id" :class="index === 0 ? 'mt-0' : 'mt-8'">{{ tag.name }}</div>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="flex items-end justify-end ml-16 whitespace-no-wrap">
        <button v-show="isSavingBtn" class="btn-heart" @click.stop="onFavoriteHandler(hotelData)">
          <i :class="{ 'text-red': hotelData.isFavorite }" class="owl-rank-heart" />
        </button>
        <div class="text-right">
          <div v-if="hotelData.tripAdvisor" class="mb-4">
            <img width="100px" :src="hotelData.tripAdvisor.logo" />
          </div>
          <div v-if="!hotelData.inStock" class="font-semibold text-sm text-right">
            <span class="text-red-dark font-bold ml-8">{{ $t('soldOut') }}</span>
          </div>
          <div v-else-if="hotelData.price && Number(hotelData.price) > 0" class="font-semibold text-grey-darkest text-lg text-right">
            <span v-if="hotelData.currency">{{ currencySign }}</span>
            <span class="ml-8">{{ Number(hotelData.price) | currencyConvert({ inputCurrency: hotelData.currency, listInteger: true }) }}</span>
          </div>
        </div>
      </div> -->
      <div v-if="hotelData.tags && hotelData.tags.length > 0" class="tags hidden md:flex items-center">
        <div v-if="hotelData.tags && hotelData.tags.length > 0" class="flex items-center">
          <template v-if="selectedLang === 'zh_TW' || selectedLang === 'zh_CN'">
            <div class="bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;" :key="hotelData.tags[0].id">{{ hotelData.tags[0].name }}</div>
            <div v-if="hotelData.tags.length > 1" class="bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;" :key="hotelData.tags[1].id">{{ hotelData.tags[1].name }}</div>
            <div v-if="hotelData.tags.length === 3" class="bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;" :key="hotelData.tags[2].id">{{ hotelData.tags[2].name }}</div>
            <el-tooltip v-if="hotelData.tags.length > 3" effect="dark" placement="right">
              <div class="tags__more bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full">{{ hotelData.tags.length - 2 }}+</div>
              <div slot="content">
                <div v-for="(tag, index) in hotelData.tags.slice(2)" :key="tag.id" :class="index === 0 ? 'mt-0' : 'mt-8'">{{ tag.name }}</div>
              </div>
            </el-tooltip>
          </template>
          <template v-else>
            <div class="bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full" style="opacity: 0.8;" :key="hotelData.tags[0].id">{{ hotelData.tags[0].name }}</div>
            <el-tooltip v-if="hotelData.tags.length > 1" effect="dark" placement="right">
              <div class="tags__more bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full">{{ hotelData.tags.length - 1 }}+</div>
              <div slot="content">
                <div v-for="(tag, index) in hotelData.tags.slice(1)" :key="tag.id" :class="index === 0 ? 'mt-0' : 'mt-8'">{{ tag.name }}</div>
              </div>
            </el-tooltip>
          </template>
        </div>
        <img v-if="hotelData.tripAdvisor" class="ml-4" width="100px" :src="hotelData.tripAdvisor.logo" />
      </div>
      <div>
        <a class="hotelCard__link inline-block text-grey-darkest" @click="mode === MODE_CLICKABLE_CONTAINER ? () => {} : goToHotel()">
          <h6 class="text-base font-semibold leading-md">{{ hotelData.hotelNameLocal }}</h6>
          <div v-if="hotelData.hotelNameEN && selectedLang !== 'en'" class="font-semibold text-md md:text-sm text-overflow-ellipsis">{{ hotelData.hotelNameEN }}</div>
        </a>
      </div>
      <div v-if="hotelData.tags && hotelData.tags.length > 0" class="tags flex items-center md:hidden">
        <div v-if="hotelData.tags && hotelData.tags.length > 0" class="small-tags w-full flex">
          <span v-for="(tag, index) in hotelData.tags" :key="tag.id" class="text-grey-darker text-sm"><span v-if="index > 0">・</span>{{ tag.name }}</span>
          <!-- <el-tooltip effect="dark" placement="right">
            <div v-if="hotelData.tags.length > 1" class="tags__more bg-grey-darkest text-white text-xs py-4 px-8 mr-4 rounded-full">{{ hotelData.tags.length - 1 }}+</div>
            <div slot="content">
              <div v-for="(tag, index) in hotelData.tags.slice(1)" :key="tag.id" :class="index === 0 ? 'mt-0' : 'mt-8'">{{ tag.name }}</div>
            </div>
          </el-tooltip> -->
        </div>
      </div>
      <div class="flex items-center justify-between">
        <div class="location text-xs" style="min-width: 0">
          <span v-if="hotelData.placesText">{{ hotelData.placesText }}</span>
          <span v-if="hotelData.hotelType && hotelData.hotelType.name !== 'unknown'" :class="{ 'border-l-1 border-grey-dark mx-8 px-8': hotelData.placesText }">{{ hotelData.hotelType.name }}</span>
        </div>
        <div class="w-full md:w-auto flex items-center justify-end md:ml-16 whitespace-no-wrap flex-no-shrink">
          <img v-if="hotelData.tripAdvisor" class="md:hidden mx-4" width="100px" :src="hotelData.tripAdvisor.logo" />
          <div v-if="!hotelData.inStock" class="font-semibold text-base text-right">
            <span class="text-red-dark font-bold ml-8">{{ $t('soldOut') }}</span>
          </div>
          <div v-else-if="hotelData.price && Number(hotelData.price) > 0" class="font-semibold text-grey-darkest text-lg text-right">
            <span v-if="hotelData.currency">{{ currencySign }}</span>
            <span class="ml-8">{{ Number(hotelData.price) | currencyConvert({ inputCurrency: hotelData.currency, listInteger: true }) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fetchListByHash } from '@/utils/filterHash.js'
import imgInfo from '@/utils/imgInfo'

const MODE_DEFAULT = 'default'
const MODE_CLICKABLE_CONTAINER = 'clickable-container'

export default {
  name: 'hotelCard',
  props: {
    hotelData: {
      type: Object,
      required: true
    },
    isSavingBtn: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: MODE_DEFAULT
    },
    starFilter: {
      type: Array,
      default: () => {
        return []
      }
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      MODE_CLICKABLE_CONTAINER,
      isSaving: false,
      coverExist: false
    }
  },
  watch: {
    isLoadingFavorite (val, oldVal) {
      if (!val && oldVal) {
        this.isSaving = false
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedLang: 'user/selectedLang',
      currencySign: 'user/currencySign',
      isLoadingFavorite: 'hotels/isLoadingFavorite',
      initWidth: 'initWidth'
    }),
    hotelCardMapImageHeight: function () {
      return 110
    },
    hotelCover: function () {
      if (this.hotelData.imageUrl) {
        return `${this.hotelData.imageUrl}?height=${this.hotelCardMapImageHeight}&format=webp`
      } else {
        return require('@/assets/images/default-room.jpg')
      }
    }
  },
  methods: {
    getStarFilter: function (starFilterHash, starData) {
      return fetchListByHash(starFilterHash, starData)
    },
    goToHotel: function () {
      if (this.isActive) {
        const route = this.$router.resolve({
          name: 'HotelDetail',
          params: { hotelId: this.hotelData.hotelUUID },
          query: {
            ...this.$route.query,
            externalId: this.hotelData.hotelUUID,
            searchId: this.hotelData.hotelUUID,
            searchType: 'hotel',
            source: this.hotelData.source
          }
        })
        window.open(route.href, '_blank')
      }
    },
    onFavoriteHandler: function (hotel) {
      this.isSaving = true
      this.hotelData.isFavorite ? this.$emit('removeFavorite', hotel) : this.$emit('addFavorite', hotel)
    }
  },
  async mounted () {
    const exist = await imgInfo.exist(this.hotelData.imageUrl)
    this.coverExist = exist
  }
}
</script>

<style lang="sass" scoped>
@import '@/assets/style/_mixins.sass'
.hotelCard
  &__item
    @apply bg-white border-1 border-grey-lighter relative overflow-hidden
    @apply flex flex-row p-8
    width: 100%
    border-radius: 20px
    // min-width: 300px
    cursor: pointer
    @apply border-t-1
    min-height: 100px
    @screen md
      @apply p-0
    &:hover
      @apply shadow
    &:active
      cursor: grabbing
      cursor: -moz-grabbing
      cursor: -webkit-grabbing
    &.activate
      @apply shadow
      @screen md
        @apply border-2 border-grey-darker
      border-radius: 20px
    &__cover
      width: 110px
      height: 110px
      @screen md
        width: 150px
      @apply mr-16
      .image
        @apply h-full
        border-radius: 20px
        padding-top: imageRatio(130, 100)
        background:
          position: center
          repeat: no-repeat
          size: cover
    &__info
      @apply flex flex-col flex-1 justify-between overflow-hidden
      .rank-wrap
        height: 16px
        width: 16px
      .location
        @apply hidden
      .tags
        // @apply hidden
        &__more
          opacity: .8
        .small-tags
          @include ellipsis(1)
    &__basic
      @apply w-full
  &__link
    max-width: 100%
    text-decoration: none
    h6
      @include ellipsis(2)
    &:hover
      text-decoration: underline
  @screen lg
    &__item
      min-width: 550px
      &__info
        @apply flex-col
        .location
          @apply block
        // .tags
          // @apply block
      &__basic
        @apply w-4/5
.btn-heart
  @apply absolute text-white text-xl outline-none
  top: 8px
  i.owl-rank-heart
    text-shadow: -1px 0 #889096, 0 1px #889096, 1px 0 #889096, 0 -1px #889096
    &:hover
      @apply text-red-light
</style>
